import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useDropzone } from "react-dropzone"


import { useRequestProcessor } from "../../api/requestProcessor"
import { uploadImage } from "../../api/upload-files"
import { getSingleBlog, updateSingleBlogs } from "../../api/blogs"
import { domainName } from "../../constants/site"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import makeAnimated from 'react-select/animated';
import Select from "react-select"
import { getAllCategoriesWithType } from "../../api/categories"
import Loading from "../../components/loading/loading"


const ViewBlog = () => {

    const [name, setName] = useState("")
    const [category, setCategory] = useState([])
    const [thumb, setThumb] = useState()

    const [blogPicture, setBlogPicture] = useState()

    const [description, setDescription] = useState("")
    const [convertedContent, setConvertedContent] = useState(null);


    const { blog_id } = useParams()


    const { Query, Mutate } = useRequestProcessor()



    const { data, isLoading, isError } = Query(
        ['getSingleBlog', blog_id],
        () => getSingleBlog(blog_id),
    );

    const { data: categoryData, isLoading: discountLoading, refetch } = Query(
        ['getAllCategoryByType', "blogs"],
        () => getAllCategoriesWithType("blogs")
    );

    useEffect(() => {
        setName(data?.data?.title)
        setDescription(data?.data?.description)
        setConvertedContent(data?.data?.body)
        setCategory(data?.data?.categories.map(el => ({ label: el.title, value: el.id })))
        let i;
        for (i = 0; i <= data?.data?.files.length; i++) {
            if (data?.data?.files[i]?.type === "cover") {
                setThumb(data?.data?.files[i].file?.thumb)
            }
            if (data?.data?.files[i]?.type === "image") {
                setBlogPicture(data?.data?.files[i].file?.thumb)
            }
        }
        console.log(data?.data?.categories.map(el => ({ label: el.title, value: el.id })));
    }, [data])

    //  react query req


    const animatedComponents = makeAnimated();
    function handleOnChange(data) {
        setCategory(data)
    }



    if (isLoading) return <Loading />


    return (
        <Layout >
            <MainPageLayout backButton sectionTitle={"مشخصات بلاگ " + data?.data?.title + " :"} title={"مشخصات بلاگ"} >
                <form >
                    <div className="flex">
                        <div className='flex flex-col mb-4 w-full'>
                            <div className='flex flex-col mb-3'>
                                <p className='pr-3 pb-1'>نام بلاگ :</p>
                                <input type="text" value={name} onChange={(e) => { }} className=' form-input !w-full' placeholder='نام بلاگ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>توضیح بلاگ:</p>
                                <div className='flex form-input !w-full items-center '>
                                    <input value={description} onChange={(e) => { }} type="text" className='form-input !w-full' placeholder='توضیح مختصر درباره بلاگ ' />
                                    <div className={`flex basis-1/4 justify-center border ${description?.length > 180 ? "!bg-red-500 text-white" : "text-green-500"} border-black rounded-xl py-2 mr-2 bg-white`}>180 / {description?.length} </div>
                                </div>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>دسته بندی :</p>
                                <Select components={animatedComponents} placeholder="بدون دسته بندی"
                                    onChange={handleOnChange} closeMenuOnSelect={false} isDisabled
                                    isMulti options={categoryData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                    value={category}

                                />
                            </div>

                        </div>
                        <div className="w-full flex flex-col mr-4">

                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'> عکس بنر :</p>
                                <div className="flex justify-center my-2">
                                    <img src={domainName + thumb} className="w-[150px]" alt="" />
                                </div>
                            </div>
                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'>عکس بلاگ :</p>

                                <div className="flex justify-center my-2">
                                    <img src={domainName + blogPicture} className="w-[150px]" alt="" />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="my-3 flex py-4 border-y">
                        <div className="flex flex-col w-full">
                            <h2 className="text-lg">مشخصات سازنده :</h2>
                            <div className="flex flex-col py-2">
                                <p>آیدی سازنده :  {data.data.creator.id}</p>
                                <p>نام سازنده :  {data.data.creator.name + " " + data.data.creator.lastname}</p>
                                <p>شماره سازنده :  {data.data.creator.phone}</p>

                            </div>
                        </div>
                        <div className='flex flex-col w-full'>
                            <h2 className="text-lg">مشخصات بلاگ :</h2>
                            <div className="flex flex-col py-2">
                                <p className=''>تعداد بازدید : {data?.data?.viewCount}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <CKEditor
                            editor={ClassicEditor}
                            disabled
                            data={convertedContent ?? ""}
                            config={{
                                language: {
                                    ui: "en",
                                    content: "ar"
                                }
                            }}
                            onReady={editor => {

                                // You can store the "editor" and use when it is needed.
                                console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();

                            }}

                        />
                    </div>

                </form>

            </MainPageLayout>
        </Layout>
    )
}

export default ViewBlog